<template>
  <label>
    <label
      class="btn btn-default btn-sm input-group-btn__icon btn-sm__file"
    >
      <span class="fa fa-cloud-upload fa-lg p-0" />
      <input
        ref="fileupload"
        type="file"
        :accept="accept"
        @change="fileUpload"
      >
    </label>
    <span
      v-if="showFileName"
      class="m-l-10"
    >
      {{ fileName && fileName !== '' ? fileName : $t('INPUT_NO_FILE') }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      default() {
        return '';
      },
    },
    fileName: {
      type: String,
      default() {
        return '';
      },
    },
    showFileName: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  methods: {
    fileUpload(ev) {
      const file = ev.target.files[0];
      if (file) {
        this.$emit('change', file);
        this.$refs.fileupload.value=null;
      }
    },
  },
};
</script>

<style>
.btn.btn-sm.btn-sm__file {
  padding-top: 6px;
}

input[type='file'] {
  display: none;
}
</style>